import { render, staticRenderFns } from "./shipmentsdispatched.vue?vue&type=template&id=663fd910&scoped=true"
import script from "./shipmentsdispatched.vue?vue&type=script&lang=js"
export * from "./shipmentsdispatched.vue?vue&type=script&lang=js"
import style0 from "./shipmentsdispatched.vue?vue&type=style&index=0&id=663fd910&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663fd910",
  null
  
)

export default component.exports